import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserStore } from '@/store/user.ts'
import { useLocallyStoredFilters } from '@/routes/projectStages/issues/lib/stores/useLocallyStoredFilters.ts'
import { redirectToLastActivePath } from '@/lib/helpers/redirectToLastActivePath.ts'

export default function useNavigateToDefaultPath() {
  const path = useLocation().pathname
  const navigate = useNavigate()

  const user = useUserStore(state => state.user)
  const tabs = useLocallyStoredFilters(s => s.tabs)

  useEffect(() => {
    if (path !== '/') return
    if (!user) {
      navigate('/login')
      return
    }
    redirectToLastActivePath({ user, navigate, tabs })
  }, [navigate, path, user, tabs])
}
